import React from 'react';
import { FormattedMessage as Fm } from 'react-intl';
// import * as Sentry from '@sentry/browser';

export default class FormattedMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }

  // eslint-disable-next-line camelcase
  unstable_handleError(e) {
    this.setState({ error: true });
    // Sentry.captureException(e);
  }

  render() {
    const { error } = this.state;
    const { backup = '' } = this.props;
    return error ? <span>{backup}</span> : <Fm {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/intl/formatted-message.jsx